// **** detalhe empresa ****
// **** autor: Walcledson de Paula ****
// ******** data: 10/08/24 18h27
// ******** data: 20/09/24 | 15h43 | limpeza do código | correção de bugs do "".tipoAtendimento" / "".tipoatendimento"
// ******** data: 08/11/24 | 22h01 | eliminamos a opção de mudar "TipoAtendimento" e levamos pra dentro da nova página "regras.jsx"
// ***********************************



import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import apiaxios from "../../../../Services/apiaxios.js";
import InputMask from 'react-input-mask';
// import { decrypt, encrypt } from "../../../../Services/cryptoUtils.js";
import { p_getUserData } from "../../../../Services/p_userutils.js";
import { decrypt } from "../../../../Services/cryptoUtils.js";
import Swal from 'sweetalert2';
// import { Row, Col, Button } from 'react-bootstrap'; // Certifique-se de importar os componentes corretamente

import { Spinner } from 'react-bootstrap'; // Você pode usar um spinner de alguma biblioteca de UI, como Bootstrap ou Material-UI
import withReactContent from 'sweetalert2-react-content';
import handleApiError from "../../../../Services/apiErrorHandler.js";
import { AutoLogout } from "../../../../Services/autologout.js";
import CardFotoPerfil from "../../../AgendexCliente/components/Perfil/fotoperfil.jsx"; // Importe o componente CardFotoPerfil

import Menu from "../../Components/Menu/p_menu.jsx";
import Footer from "../../../AgendexCliente/components/Footer/footer.jsx";

import './p_detalheempresa.css';

function DetalheEmpresa() {
    // verifica tokens
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, [tokenASW]);

    const initialUserData = p_getUserData();
    const [id_usuario, setIdUsuario] = useState(initialUserData.userId); // Usar setIdUsuario para atualizar o id_usuario
    // const [tipoAtendimento, setTipoAtendimento] = useState(initialUserData.tipoAtendimento); // 0 = não possui colaboradores, 1 = possui colaboradores
    const [validado, setValidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    const [bloqueio, setBloqueio] = useState(initialUserData.bloqueio); // se contrato vencido ou não (0= não vencido / 1=vencido)
    
    const [loading, setLoading] = useState(false);
    const [nome, setNome] = useState('');
    const [fone, setFone] = useState('');
    const [fonefixo, setFoneFixo] = useState('');
    const [uf, setUf] = useState('');
    const [cidade, setCidade] = useState('');
    const [bairro, setBairro] = useState('');
    const [endereco, setEndereco] = useState('');
    const [dtcadastro, setDtCadastro] = useState('');
    const [dtvalidacao, setDtValidacao] = useState('');
    const [dtdesbloqueio, setDtDesbloqueio] = useState('');
    const [ativaconta, setAtivaconta] = useState(0);
    // const [validado, setValidado] = useState('');
    // const [bloqueio, setBloqueio] = useState('');
    const [linkpersonalizado, setLinkpersonalizado] = useState('');
    const [linkvazio, setLinkvazio] = useState('');
    const [periodocontrato, setPeriodoContrato] = useState(0);
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [isEditable, setIsEditable] = useState(false);
    const [salvar, setSalvar] = useState(false);
    const [showCardFotoPerfil, setShowCardFotoPerfil] = useState(false); // Novo estado
    const navigate = useNavigate();

    const foneRef = useRef(null);

    // carrega dados da empresa e linkpersonalizado, se houver
    useEffect(() => {
        carregaDados(id_usuario);
        setLinkpersonalizado(linkvazio);
    }, [id_usuario, linkvazio]); // Adicionar id_usuario e linkvazio como dependência para recarregar dados quando ele mudar 12/9/24w 15h42

    const MySwal = withReactContent(Swal);

    // carrega todos os dados da empresa
    const carregaDados = async (idUsuario) => {
        setLoading(true);
        try {
            const response = await apiaxios.get('/empresa/carregarWeb', {
                params: { id_empresa: idUsuario,
                        token: tokenASW,
                        id_usuario: idUsuario
                }
            });
            if (response.status === 200) {
                const data = response.data;
                // console.log (data);
                if (data.retorno === 'OK') {
                    setNome(data.nome);
                    setUf(data.estado);
                    setCidade(data.cidade);
                    setBairro(data.bairro);
                    setEndereco(data.endereco);
                    setFone(data.celular);
                    setFoneFixo(data.fone);
                    setDtCadastro(data.dt_cadastro.toLocaleString());
                    setDtValidacao(data.dt_validacao.toLocaleString());
                    setDtDesbloqueio(data.dt_unlock.toLocaleString());
                    setPeriodoContrato(data.periodo_contrato + ' dias');
                    setBloqueio(Number(data.lock));
                    setAtivaconta(Number(data.ativa_conta));
                    setValidado(Number(data.validado));
                    setLinkvazio(data.link_personalizado);
                    setFotoPerfil(`data:image/jpeg;base64,${data.foto}`);
                } else {
                    Swal.fire('Erro', data.retorno, 'error');
                }
            } else {
                Swal.fire('Erro', 'Falha ao carregar os dados de sua empresa. Tente novamente mais tarde.', 'error');
            }
        } catch (error) {
            handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // console.log('validado dentro de detalhe empresa: ', validado);
        // console.log('bloqueio dentro de detalhe empresa: ', bloqueio);
        // if (validado === 0 || validado === undefined || validado === null) {
        if (validado !== 1) {
                Swal.fire('Erro', 'Cadastro em validação... favor aguardar e tentar novamente mais tarde!', 'error');
            navigate('/app/prestador/home');
        } else if (bloqueio !== 0) {
            Swal.fire('Contrato Vencido', 'Cadastro bloqueado. Escolha um de nossos planos para continuar usando o AgendeX', 'error');
            navigate('/app/prestador/home');
        }
    }, [validado, bloqueio, navigate]); // acrescetando 12/9/24w "navigate" pois estava gerando o hint/warning: "Line 147:8:   React Hook useEffect has a missing dependency: 'navigate'. Either include it or remove the dependency array"
    
    const handleEditProfile = () => {
        setIsEditable(true);
        setSalvar(true);
        setTimeout(() => {
            if (foneRef.current && foneRef.current.inputElement) {
                foneRef.current.inputElement.focus();
            }
        }, 0);
    };

    const handleCancelEdit = () => {
        setIsEditable(false);
        setSalvar(false);
    };

    const validatePhone = (input) => {
        return input.replace(/\D/g, ''); // Remove todos os caracteres não numéricos
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validação do link personalizado
        if (linkpersonalizado && linkpersonalizado.length < 5) {
            MySwal.fire('Erro', 'O link personalizado deve ter no mínimo 5 caracteres.', 'error');
            return;
        }
        if (linkpersonalizado && linkpersonalizado.length > 30) {
            MySwal.fire('Erro', 'O link personalizado deve ter no máximo 30 caracteres.', 'error');
            return;
        }
        
        // regras link_personalizado: mínimo 5 caracteres - máximo de 30. obrigatório letra no início. somente letras minúsculas, números, (-) e (_) 9/8/24w
           const validLinkRegex = /^[a-zA-Z][a-zA-Z0-9-]{4,29}$/;

        if (linkpersonalizado && !validLinkRegex.test(linkpersonalizado)) {
            MySwal.fire('Erro', 'O link personalizado deve começar com uma letra e conter apenas letras, números, traço (-) e underline (_), com pelo menos 5 caracteres.', 'error');
            return;
        }
        
        const result = await MySwal.fire({
            title: 'Confirmação!',
            text: "Você confirma alteração dos dados de sua empresa?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, alterar!',
            cancelButtonText: 'Cancelar!'
        });

        if (result.isConfirmed) {
            try {
                const response = await apiaxios.put('/empresa/cadastroWeb', {
                    id_empresa: id_usuario,
                    nome,
                    endereco,
                    bairro,
                    fone,
                    fonefixo,
                    linkpersonalizado
                },
                {
                    params: { token: tokenASW,
                            id_usuario }
                });
                if (response.status === 200) {
                    MySwal.fire('Sucesso', 'Dados da Empresa alterados com sucesso!', 'success');
                    navigate('/app/prestador/home');
                } else {
                    MySwal.fire('Erro', 'Falha ao alterar dados da empresa. Tente novamente.', 'error');
                }
            } catch (error) {
                const errorMessage = error.response?.data?.retorno || 'Erro de conexão. Verifique sua conexão e tente novamente.';
                MySwal.fire('Erro', errorMessage, 'error');
            }
        } else {
            handleCancelEdit()
        }
    };

    // Valida quando o campo "link_personalizado" perde o foco (evento onBlur)
    const handleBlur = async (e) => {
        e.preventDefault();

        // regras link_personalizado: mínimo 5 caracteres - máximo de 30. obrigatório letra no início. somente letras minúsculas, números, (-) e (_) 9/8/24w
        if (linkpersonalizado && linkpersonalizado.length > 30) {
            MySwal.fire('Erro', 'O link personalizado deve ter no máximo 30 caracteres.', 'error');
            return;
        }
        
        const validLinkRegex = /^[a-zA-Z][a-zA-Z0-9-_]{4,30}$/;

        if (linkpersonalizado && !validLinkRegex.test(linkpersonalizado)) {
            MySwal.fire('Erro', 'O link personalizado deve começar com uma letra e conter apenas letras, números, traço (-) e underline (_), com pelo menos 5 caracteres.', 'error');
            return;
        }
    };



    return (
        <div>
            <div className="container-fluid">
                <div className="row flex-nowrap">
                    <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                        <Menu page="detalheempresa" />
                    </div>
                    <div className="col py-3 me-3">
                        <div className="text-center">
                            <h1>Detalhe Empresa</h1>
                        </div>
                        <hr />

                        {/* Verifique se o loading está ativo */}
                        {loading ? (
                            // Mostra um spinner de carregamento
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </Spinner>
                            </div>
                            ) : (
                            // Renderiza o conteúdo normalmente
                            <div className="col py-3 me-3">
                                <div className="img-usuario text-center">
                                    <img src={fotoPerfil} className="usuario-foto" alt="sem foto da empresa" onClick={() => setShowCardFotoPerfil(true)} />
                                    {showCardFotoPerfil && (
                                    <div className="col-lg-3 ml-10 col-md-4 col-sm-12">
                                        <CardFotoPerfil userId={id_usuario} />
                                    </div>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="box-perfil">
                            <form>
                                <hr />
                                <div className="row mb-3">
                                    <label htmlFor="perfilnome" className="col-sm-2 col-form-label">Nome Fantasia</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfilnome" placeholder="Nome de Fantasia cadastrado no Agendex" autoComplete="username" value={nome} />
                                    </div>
                                </div>
                                <hr />
                                <div className="row mb-3">
                                    <label htmlFor="perfilendereco" className="col-sm-2 col-form-label">Endereço Completo</label>
                                    <div className="col-sm-10">
                                        <input disabled={!isEditable} type="text" className="form-control" id="perfilendereco" placeholder="Endereço cadastrado no Agendex" autoComplete="endereco" value={endereco} 
                                            onChange={(e) => setEndereco(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfilbairro" className="col-sm-2 col-form-label">Bairro</label>
                                    <div className="col-sm-10">
                                        <input disabled={!isEditable} type="text" className="form-control" id="perfilbairro" placeholder="Bairro onde sua empresa está localizada" autoComplete="bairro" value={bairro} 
                                            onChange={(e) => setBairro(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfilcidade" className="col-sm-2 col-form-label">Cidade</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfilcidade" placeholder="Cidade sede de sua empresa" autoComplete="cidade" value={cidade} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfiluf" className="col-sm-2 col-form-label">Estado/UF</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfiluf" placeholder="Estado/UF onde fica sua empresa" autoComplete="uf" value={uf} />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfillink" className="col-sm-2 col-form-label">Link Personalizado</label>
                                    <div className="col-sm-10">
                                        <input 
                                            disabled={!isEditable || linkvazio !==''}
                                            type="text" 
                                            className="form-control" id="perfillink" 
                                            placeholder="'Link Personalizado' de seu negócio para facilitar agendamentos" 
                                            autoComplete="linkpersonalizado" 
                                            value={linkpersonalizado} 
                                            onChange={(e) => setLinkpersonalizado(e.target.value)}
                                            onBlur={handleBlur} // Adiciona o evento onBlur para validação
                                        />
                                    </div>
                                    <label htmlFor="perfillinkAgendar" className="ms-2 text-primary bg-dark col-sm-12 col-form-label">Agendex.net.br/agendar/{linkpersonalizado}</label>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilfone" className="col-sm-2 col-form-label">Telefone preferencial(celular)</label>
                                    <div className="col-sm-10">
                                        <InputMask
                                            mask={fone.length === 13 ? "(99)9999-9999" : "(99)99999-9999"}
                                            disabled={!isEditable}
                                            type="text"
                                            className="form-control"
                                            id="perfilfone"
                                            placeholder="Telefone (preferencial WhatsApp)"
                                            autoComplete="fone"
                                            value={fone}
                                            onChange={(e) => setFone(validatePhone(e.target.value))}
                                            ref={foneRef}
                                        />                                    
                                    </div>
                                </div>
                                
                                <div className="row mb-3">
                                    <label htmlFor="perfilfonefixo" className="col-sm-2 col-form-label">Telefone Opcional</label>
                                    <div className="col-sm-10">
                                        <InputMask
                                            mask={fonefixo.length === 13 ? "(99)9999-9999" : "(99)99999-9999"}
                                            disabled={!isEditable}
                                            type="text"
                                            className="form-control"
                                            id="perfilfonefixo"
                                            placeholder="Telefone fixo ou outro celular com DDD"
                                            autoComplete="fone"
                                            value={fonefixo}
                                            onChange={(e) => setFoneFixo(validatePhone(e.target.value))}
                                            ref={foneRef}
                                        />                                    
                                    </div>
                                </div>

                                <hr />

                                <div className="row mb-3">
                                    <label htmlFor="perfidtcadastro" className="col-sm-2 col-form-label">Data de Cadastro</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfidtcadastro" placeholder="Data do cadastrado realizado no Agendex" autoComplete="datacadastro" value={dtcadastro} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfidtvalidacao" className="col-sm-2 col-form-label">Data de Validação</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfidtvalidacao" placeholder="Data da validação do seu cadastrado no Agendex" autoComplete="datavalidacao" value={dtvalidacao} />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfidtdesbloqueio" className="col-sm-2 col-form-label">Data de Desbloqueio</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfidtdesbloqueio" placeholder="Data de desbloqueio do seu cadastro após fim do contrato..." autoComplete="datadesbloqueio" 
                                        value={dtdesbloqueio} />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <label htmlFor="perfilconta" className="col-sm-2 col-form-label">Situação do Email</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className={`form-control ${ativaconta === 0  ? 'btn btn-danger' : 'btn btn-success' }`} id="perfilsituacaoemail" placeholder="situação da conta"
                                            value={`${ativaconta === 0 ? 'Você precisa validar seu email' : 'Email verificado'}`}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfilcpfcnpj" className="col-sm-2 col-form-label">Situação do CPF/CNPJ</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className={`form-control ${validado === 0  ? 'btn btn-danger' : 'btn btn-success' }`} id="perfilsituacaocpfcnpj" placeholder="situação do CPF/CNPJ"
                                            value={`${validado !== 1 ? '... aguarde validação do seu CPJ/CNPJ' : 'Conta liberada para oferecer agendamentos'}`}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label htmlFor="perfilcontrato" className="col-sm-2 col-form-label">Contrato</label>
                                    <div className="col-sm-10">
                                        <input disabled type="text" className="form-control" id="perfilcontrato" placeholder="Tipo do contrato no Agendex" autoComplete="contrato" value={periodocontrato}/>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="d-flex justify-content-between">
                            <button type="button" className="btn btn-primary" onClick={handleEditProfile} disabled={isEditable}>Alterar dados da empresa</button>
                            <button type="button" className="btn btn-danger" onClick={handleSubmit} disabled={!isEditable}>Salvar alterações</button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default DetalheEmpresa;